/* --------------------------------------------------------------------------------------
   scanBrowse.component.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const scanSettingsComponent = {
  template: require("./scanSettings.html"),
  controllerAs: "vm",
  controller: class scanSettingsController {
    /* @ngInject */
    constructor(
      commonService,
      scanService,
      jobStatusService,
      sessionDataService,
      xeroxEIPParameters,
      expensesService,
      ssoClientService,
      $translate,
      $state
    ) {
      this.commonService = commonService;
      this.scanService = scanService;
      this.jobStatusService = jobStatusService;
      this.sessionDataService = sessionDataService;
      this.$translate = $translate;
      this.$state = $state;
      this.xeroxEIPParameters = xeroxEIPParameters;
      this.expensesService = expensesService;
      this.ssoClientService = ssoClientService;
    }

    async $onInit() {
      this.buildLogoutConfirmButtons();
      this.screenSize = this.commonService.getScreenSize();
      this.preview = true;
      if (!this.scanService.filename) {
        this.scanService.filename = "Xerox Scan [Date & Time].pdf";
      }
      await this.scanService.setOptions();
      await this.scanService.setDefaultLanguage();
      await this.scanService.setDefaults();
      this.loaded = true;
      this.commonService.updateView();
    }

    async ok() {
      if (this.loaded) {
        this.profileId = await this.scan();
        if (this.preview) {
          this.previews = await this.getPreviews();
          this.commonService.updateView();
        } else {
          await this.saveFile();
        }
      }
    }

    async scan() {
      const activityLabelTranslationKey = this.preview
        ? "GENERATING_PREVIEW"
        : "SCANNING_DOCUMENT";
      this.activityLabel = await this.$translate(activityLabelTranslationKey);
      this.activity = true;
      this.commonService.updateView();
      const scanProfileId = this.commonService.getNewGuid();

      try {
        const jobId = await this.scanService.scan(
          scanProfileId,
          this.sessionDataService.scanFolder,
          this.scanService.filename,
          false,
          0
        );
        await this.jobStatusService.getScanFinishedStatus(jobId);
      } catch (e) {
        this.error = e;
      } finally {
        this.activity = false;
        this.commonService.updateView();
      }

      return scanProfileId;
    }

    async getPreviews() {
      try {
        this.pagecount = await this.scanService.getPreviewPageCount(
          this.profileId
        );
        if (!this.pagecount) throw "Scan failed";
        let result = [];
        for (var i = 0; i < this.pagecount; i++) {
          result.push(
            this.scanService.getImageUrl(
              "/scan/thumb/" + this.profileId + "/" + i
            )
          );
        }
        return result;
      } catch (e) {
        this.error = e + " - " + this.sessionDataService.lastStatus;
      }
    }

    async saveFile() {
      this.activityLabel = await this.$translate("SENDING_TO_CLIO");
      this.isSaving = true;
      this.activity = true;

      if (!this.preview)
        this.pagecount = await this.scanService.getPreviewPageCount(
          this.profileId
        );

      await this.scanService.saveFile(this.profileId);
      await this.expensesService.sendExpenses(
        "scan",
        this.sessionDataService.matter,
        this.pagecount,
        this.sessionDataService.user
      );

      this.activity = false;
      this.commonService.updateView();
    }
    cancel() {
      this.previews = null;
    }

    onActivityClose() {
      /*      console.log(this.isSaving)
      if (this.isSaving)
        this.$state.go('main')*/
    }

    selectTwoSidedScan(value) {
      this.scanService.twoSidedScan =
        this.scanService.twoSidedScanOptions[value.index].key;
      this.scanService.twoSidedScanText = value.label;
      this.commonService.updateView();
    }

    selectResolution(value) {
      this.scanService.resolution =
        this.scanService.resolutionOptions[value.index].key;
      this.scanService.resolutionText = value.label;
      this.commonService.updateView();
    }

    selectOutputColor(value) {
      this.scanService.outputColor =
        this.scanService.outputColorOptions[value.index].key;
      this.scanService.outputColorText = value.label;
      this.commonService.updateView();
    }

    selectOriginalType(value) {
      this.scanService.originalType =
        this.scanService.originalTypeOptions[value.index].key;
      this.scanService.originalTypeText = value.label;
      this.commonService.updateView();
    }
    selectOriginalOrientation(value) {
      this.scanService.originalOrientation =
        this.scanService.originalOrientationOptions[value.index].key;
      this.scanService.originalOrientationText = value.label;
      this.commonService.updateView();
    }
    selectOriginalSize(value) {
      const selectedSize = this.scanService.originalSizeOptions[value.index];
      console.log(selectedSize);
      this.scanService.originalSize = selectedSize.key;
      this.scanService.originalSizeText = selectedSize.value;
      this.scanService.originalSizeOrientation = selectedSize.orientation;
      this.commonService.updateView();
    }

    async reset() {
      this.preview = true;
      await this.scanService.setDefaults();
      this.commonService.updateView();
    }

    // logout button code
    async buildLogoutConfirmButtons() {
      this.confirmLogoutButtons = [
        {
          alertIcon: "glyphicon-close",
          text: await this.$translate("CANCEL"),
          click: () => this.cancelLogout(),
        },
        {
          alertIcon: "glyphicon-exit",
          text: await this.$translate("LOG_OUT"),
          click: () => this.logout(),
        },
      ];
    }

    showConfirmLogout() {
      this.confirmLogout = true;
    }
    cancelLogout() {
      this.confirmLogout = false;
      this.commonService.updateView();
    }

    logout() {
      this.ssoClientService.logout();
      this.$state.go("login");
    }

    getOrientationGlyph(orientation) {
      switch (orientation) {
        case "P":
          return "glyphicon-short-edge-feed";
        case "L":
          return "glyphicon-long-edge-feed";
        default:
          return null;
      }
    }

    errorClosed() {
      this.error = null;
      this.commonService.updateView();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/scan/components/scanSettings.component.js